
    import { Component, Vue } from 'vue-property-decorator';
    import { mapActions, mapState } from 'vuex';
    import Beleg from '@/types/Beleg';
    import { CompareFunction, DataTableHeaders } from '@/types';
    import Kassaabschluss from '@/types/Kassaabschluss';

    @Component({
        computed: {
            ...mapState('globals', ['sortDate']),
            ...mapState('kassafuehrung', ['kassaabschluesse', 'loaders']),
        },
        methods: {
            ...mapActions('kassafuehrung', ['loadKassaabschlussliste']),
        },
    })
    export default class KassaabschlussDataTable extends Vue {
        public loadKassaabschlussliste!: (abschlussnr: number) => void;
        public sortDate!: CompareFunction<Kassaabschluss>;

        public get headers(): DataTableHeaders<Kassaabschluss, 'actions' | 'am_von'> {
            return [
                { text: '', value: 'actions', sortable: false, width: 50 },
                { text: 'Datum', value: 'datum', sort: this.sortDate },
                { text: 'Anfangssaldo', value: 'anfangssaldo', align: 'end' },
                { text: 'Saldo', value: 'saldo', align: 'end' },
                { text: 'Gesamtbetrag', value: 'gesamtbetrag', align: 'end' },
                { text: 'Eingetragen am/von', value: 'am_von', sortable: false },
            ];
        }

        public onClickListe({ abschlussnr }: Beleg): void {
            this.loadKassaabschlussliste(abschlussnr as number);
        }
    }
